export enum Languages {
	en = 'en-US',
	nl = 'nl-NL',
}
